import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from 'yup';
import React, { useEffect, useRef, useState } from 'react'
import Rights from './Rights';
import { getCategoria,  getTipoDenuncia, getTipoRelacion, getTextosConfig, getCodeConsulta} from '../../services/denunciaService';
import axios from 'axios';
import Swal from 'sweetalert2';
import * as notification from "../../utils/notification";
import { Row, Col, Button, InputGroup, Input as InputReact } from "reactstrap";
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { ModalCode } from "../common/ModalCode";

const Denuncia = ({ showDenuncia, setShowDenuncia }) => {

    const [categorias, setCategorias] = useState([]);
    const [archivo, setArchivo] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [clearName, setClearName] = useState();
    const [clearPhone, setClearPhone] = useState();
    const [clearEmail, setClearEmail] = useState();
    const fileRef1 = useRef();
    const [tipoDenuncia, setTipoDenuncia] = useState([]);
    const [tipoRelacion, setTipoRelacion] = useState([]);
    const [textosConfig, setTextosConfig] = useState([]);
    const [code, setCode] = useState('');
    const[password, setPassword] = useState();

    const [modalState, setModalState] = useState(false);
    const [text, setText] = useState('');
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
        getCategorias();
        getTipoDenuncias();
        getTiposRelacion();
        getTextoConfig();
        getCode();
    }, [])

    const getCode = async () => {
        const response = await getCodeConsulta();
        setCode(response.code);
        setPassword(response.password);
    }

    const getCategorias = async () => {
        const response = await getCategoria();
        const categoriasActivas = response.filter(cat => cat.isActive);
        setCategorias(categoriasActivas);
    }

    const getTipoDenuncias = async () => {
        const response = await getTipoDenuncia();
        setTipoDenuncia(response);
    }

    const getTiposRelacion = async () => {
        const response = await getTipoRelacion();
        setTipoRelacion(response);
    }

    const getTextoConfig = async () => {
        const response = await getTextosConfig();
        setTextosConfig(response);
    }
    const inputHandlerCode = event => {
        setText(event.target.value);
    }
    const inputHandlerPassword = event => {
        setText(event.target.value);
    }
    const copy = async () => {
        await navigator.clipboard.writeText(code);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
    }
    const copyPassword = async () => {
        await navigator.clipboard.writeText(password);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
    }

    const handleSubmit = async (data, resetForm) => {
        const formData = new FormData();

        formData.append("nombre", clearName);
        formData.append("telefono", clearPhone);
        formData.append("email", clearEmail);
        formData.append("esAnonimo", data.esAnonimo);
        formData.append("nombrePersonaDenunciada", data.nombrePersonaDenunciada);
        formData.append("descripcionDenuncia", data.descripcionDenuncia);
        formData.append("periodoDeHechos", data.periodoDeHechos);
        formData.append("documento", archivo);
        formData.append("checked", data.checked);
        formData.append("checkedDenuncia", data.checkedDenuncia);
        formData.append("checkedRelacion", data.checkedRelacion);
        formData.append("aceptaTerminos", data.aceptaTerminos);
        formData.append("domicilio", data.domicilio);
        formData.append("lugar", data.lugar);
        formData.append("code", code)
        formData.append("password", password)

        try {
            await axios({
                method: 'post',
                url: "form/denuncia",
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(({ data }) => {
                if (data.success) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Consulta enviada correctamente',
                        showConfirmButton: false,
                        timer: 1000
                    })
                    setModalState(true);
                    resetForm();
                } else {
                    setModalState(false);
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'No se ha podido guardar',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            })
        } catch (error) {
            notification.error("", error.message || "Problemas en la llamada al servidor");
        }
    }

    const handleCancel = () => {
        setShowDenuncia(!showDenuncia)
    }

    const handleChangeName = (e) => {
        console.log(e);
        setClearName(e.target.value)
    }

    const handleChangePhone = (e) => {
        console.log(e);
        setClearPhone(e.target.value)
    }

    const handleChangeEmail = (e) => {
        console.log(e);
        setClearEmail(e.target.value)
    }

    const HtmlTooltip = withStyles((theme) => ({
        tooltip: {
          backgroundColor: '#f5f5f9',
          color: 'rgba(0, 0, 0, 0.87)',
          maxWidth: 1120,
          fontSize: theme.typography.pxToRem(14),
          border: '1px solid #dadde9',
          float:'right',
        },
      }))(Tooltip);

    return (
        <div>
            <Formik
                initialValues={{
                    nombre: '',
                    telefono: '',
                    email: '',
                    domicilio: '',
                    lugar: '',
                    esAnonimo: false,
                    nombrePersonaDenunciada: '',
                    descripcionDenuncia: '',
                    periodoDeHechos: '',
                    documento: archivo,
                    checked: [],
                    checkedDenuncia: [],
                    checkedRelacion: '',
                    aceptaTerminos: false,
                    code: ''

                }}
                onSubmit={(values, { resetForm }) => {
                    handleSubmit(values, resetForm);
                    // setShowDenuncia(!showDenuncia)
                }}
                validationSchema={
                    Yup.object({
                        nombre: Yup.string(),
                        telefono: Yup.string()
                            .matches(/(\+34|0034|34)?[ -]*(6|7)[ -]*([0-9][ -]*){8}/, { message: "Ingrese un número válido.", excludeEmptyString: false }),
                        email: Yup.string()
                            .email('El correo no tiene un formato válido'),
                        esAnonimo: Yup.boolean(),
                        nombrePersonaDenunciada: Yup.string()
                            .max(20, 'Debe de tener 20 caracteres o menos')
                            .required('Requerido'),
                        descripcionDenuncia: Yup.string()
                            .min(10, 'El texto es muy corto, debe tener al menos 10 caracteres'),
                        documento: Yup.mixed().test("FILE_SIZE", "El archivo no debe superar los 5mb",
                            (value) => fileRef1.current.files[0] !== undefined ? (fileRef1.current.files[0].size <= 5000000 ? true : false) : true),
                        periodoDeHechos: Yup.date()
                            .required('Requerido'),
                        checkedRelacion: Yup.string().required("Debe seleccionar uno"),
                        checkedDenuncia: Yup.array()
                            .min(1, 'Debe seleccionar al menos uno'),
                        checked: Yup.array()
                            .min(1, 'Debe seleccionar al menos uno'),
                        aceptaTerminos: Yup.boolean()
                            .oneOf([true], ' Debe aceptar los terminos')
                    })
                }
            >
                {
                    formik => (
                        <Form>
                            <div className="denuncia__main mt-0">
                                <div className="mb-5">
                                <p className='denuncia__title'>Anonimato</p>
                                            <label className="form__checkbox-label">
                                                <Field name="esAnonimo" type="checkbox" onClick={() => {
                                                    setDisabled(!disabled);
                                                    setClearName(() => '');
                                                    setClearPhone(() => '');
                                                    setClearEmail(() => '');
                                                }} />
                                                    Prefiero mantener mi anonimato
                                            </label>
                                            <label className="form__checkbox-label ml-4"> CODIGO : {code ? code : ''} </label>
                                            <ErrorMessage name="esAnonimo" component="span" />
                                </div>
                                <div className="mb-5">
                                    <p className='denuncia__title'>Datos de Contacto</p>
                                    <div>
                                        <Field disabled={disabled} value={ clearName } name='nombre' type='text' placeholder='Nombres y Apellidos *' className="form__input" onChange={ handleChangeName }/>
                                        <ErrorMessage name='nombre' component='span' />
                                    </div>
                                    <div>
                                        <Field disabled={disabled} value={ clearPhone } name='telefono' type='text' placeholder='Teléfono de Contacto *' className='form__input' onChange={ handleChangePhone }/>
                                        <ErrorMessage name='telefono' component='span' />

                                        <Field disabled={disabled} value={ clearEmail } name='email' type='email' placeholder='Correo electrónico *' className='form__input' onChange={ handleChangeEmail }/>
                                        <ErrorMessage name='email' component='span' />

                                        <Field name='domicilio' type='text' placeholder='Domicilio' className='form__input' />
                                        <ErrorMessage name='domicilio' component='span' />

                                        <Field name='lugar' type='text' placeholder='Lugar seguro para recepción de comunicaciones' className='form__input' />
                                        <ErrorMessage name='lugar' component='span' />
                                    </div>

                                </div>
                                <div className="mb-5">
                                    <p className='denuncia__title'>Tipo de relación del denunciante con MEDIASET ESPAÑA</p>
                                    <label className="form__checkbox-label">
                                    <Row>
                                    {
                                        tipoRelacion.map(relacion => (
                                            <Col md="6" key={relacion.description}>
                                                <label className="form__checkbox-label">
                                                <Field
                                                    type="radio"
                                                    name="checkedRelacion"
                                                    className="checkbox"
                                                    value={relacion.tipoRelacionId.toString()}
                                                   />
                                                   {relacion.description}
                                                </label>
                                            </Col>
                                        ))
                                    }
                                    </Row>
                                    </label>
                                    <ErrorMessage name='checkedRelacion' component='span' />
                                </div>
                                <div className="mb-5">
                                    <p className='denuncia__title'>Persona o personas sobre las que se ejerce la denuncia</p>
                                    <div>
                                        <Field className="form__input" name='nombrePersonaDenunciada' type='text' placeholder='Nombres y Apellidos *'></Field>
                                        <ErrorMessage name='nombrePersonaDenunciada' component='span' />
                                    </div>
                                    <div>
                                        <Field className="form__input form__textarea mt-1" name='descripcionDenuncia' as='textarea' placeholder='Describa brevemente los hechos en los que base su denuncia *'></Field>
                                        <ErrorMessage name='descripcionDenuncia' component='span' />
                                    </div>
                                    <div>
                                        <label className="denuncia__title">Período aproximado de los hechos denunciados  *
                                        <Field className="form__input form__date" name='periodoDeHechos' type='date'></Field>
                                        </label>
                                        <ErrorMessage name='periodoDeHechos' component='span' />
                                    </div>
                                </div>
                                <div className="mb-8">
                                    <p className='denuncia__title'>Tipo de denuncia</p>
                                    <div className='form__checkbox-label mb-2' id="checkbox-group">Al menos debe seleccionar una categoría *</div>
                                    <div className="form__checkox-container form__checkbox-label" role="group" aria-labelledby="checkbox-group">
                                    <Row md="8">
                                    {
                                        tipoDenuncia.map(denuncia => (
                                            <Col md="10" key={denuncia.description}>
                                                <label>
                                                    <Field type="checkbox" className="checkbox" name="checkedDenuncia" value={denuncia.tipoDenunciaId.toString()} />
                                                    {denuncia.description}
                                                    {denuncia.tipoDenunciaId == 1 ?
                                                    // <div className="changePassword">
                                                    <HtmlTooltip
                                                    title={
                                                      <React.Fragment>
                                                        {textosConfig.map(textos => (
                                                            <div>
                                                            {textos.key == "TipoDenunciaTexto1" ?
                                                            <Row>
                                                            <Col><div dangerouslySetInnerHTML={{ __html: textos.value }}></div></Col>
                                                            </Row>
                                                            : ''}
                                                            </div>
                                                        ))}
                                                      </React.Fragment>
                                                    }
                                                  >
                                                    <label>(i)</label>
                                                    </HtmlTooltip>
                                                    // </div>
                                                    : ''}

                                                </label>
                                            </Col>
                                        ))
                                    }
                                    </Row>
                                    </div>
                                    <ErrorMessage name='checkedDenuncia' component='span' />
                                </div>
                                <div className="mb-5">
                                    <p className='denuncia__title'>Categoría</p>
                                    <div className='form__checkbox-label mb-2' id="checkbox-group">Al menos debe seleccionar una categoría *</div>
                                    <div className="form__checkox-container form__checkbox-label" role="group" aria-labelledby="checkbox-group">
                                        <Row>

                                            {
                                                categorias.map(cat => (
                                                    <Col md="6" key={cat.name}>
                                                        <label>
                                                            <Field type="checkbox" className="checkbox" name="checked" value={cat.id.toString()} />
                                                            {cat.name}
                                                        </label>
                                                    </Col>
                                                ))
                                            }
                                        </Row>
                                    </div>
                                    <ErrorMessage name='checked' component='span' />
                                </div>

                                <div>
                                    <p className='denuncia__title'>Agregar documento</p>
                                    <p className="form__checkbox-label">Documentación para anexar a la denuncia de cara a completar o dar soporte a los hechos denunciados</p>
                                    <input
                                        ref={fileRef1}
                                        className="form__input mb-3"
                                        name="documento" type='file'
                                        placeholder='Adjuntar archivo (pdf, word, jpg…)'
                                        onChange={(e) => {
                                            setArchivo(e.target.files[0])
                                        }
                                        }
                                    />
                                    <ErrorMessage name="documento" component="span" />
                                </div>
                                <div className="mb-5">
                                    <p className='denuncia__title'>CLÁUSULA SOBRE LA  PROTECCIÓN AL DENUNCIANTE</p>
                                    <div className='form__checkbox-label mb-2'>
                                    {textosConfig.map(textos => (
                                        <div>
                                        {textos.key == "Clausulas" ?
                                        <Row>
                                        <Col><div dangerouslySetInnerHTML={{ __html: textos.value }}></div></Col>
                                        </Row>
                                        : ''}
                                        </div>
                                    ))}
                                    </div>
                                </div>
                                <div>
                                    <p className='denuncia__title'>Protección de datos personales</p>
                                        <div className='mb-2'>
                                            <label className="form__checkbox-label">
                                            <Field
                                                name="aceptaTerminos" type="checkbox" />
                                                He leído y comprendido la información sobre el <a>tratamiento del canal de denuncias</a>
                                            </label>
                                            <ErrorMessage name="aceptaTerminos" component="span" />
                                        </div>
                                </div>
                                <Rights/>
                                <div className="form__button-container">
                                    <button type='reset' className='btn btn-cancel' onClick={ handleCancel }>Cancelar</button>
                                    <button role='button' type='submit' className='btn btn-primary'>Enviar</button>
                                </div>

                            </div>
                        </Form>
                    )
                }

            </Formik>
            <ModalCode        
                modalState={modalState}
                setModalState={setModalState}
                showOverlay={true}
                positionModal={'center'}
                padding={'0px '}
                >
                <div className="contenido-modal">
                    <h4 className="txt-modal">Guarde este código y contraseña para realizar seguimiento de su consulta</h4>
                    <InputGroup
                    className="input-code"
                    >
                    <Row><Col>Código</Col></Row>
                    <Row className='mb-2'>                       
                            <InputReact
                                className="txt-code"
                                value={code}
                                onChange={inputHandlerCode}
                            />
                            <Button
                                className="btn-input-code"
                                onClick={copy}
                                disabled={!code}
                            >
                                Copiar
                            </Button>
                    </Row>
                    <Row><Col>Contraseña</Col></Row>
                    <Row>                        
                            <InputReact
                                className="txt-code"
                                value={password}
                                onChange={inputHandlerPassword}
                            />
                            <Button
                                className="btn-input-code"
                                onClick={copyPassword}
                                disabled={!password}
                            >
                                Copiar
                            </Button>
                    </Row>
                    </InputGroup>
                    {
                    isCopied && (
                        <span className="span-copied">¡Copiado!</span>
                    )
                    }
                    <p className="msje-code">Se ha enviado correctamente. Guarde el código y contraseña para realizar cualquier consulta</p>
                    <button 
                    className="btn btn-primary btn-ok"
                    onClick={() => {
                        setModalState(false);
                        setShowDenuncia(false)
                    }}
                    >Ok</button>
                </div>
            </ModalCode>
        </div>

        
    )
}

export default Denuncia
